import * as React from 'react';
import { ValidationProps } from 'ui';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { CodePickerProps, CodePickerState } from '../../../../codetable/common/code-picker/types';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

interface CodeMultipleHierarchyPickerProps extends CodePickerProps {
  validation?: ValidationProps;
  valueItems: CodeComplexValue<number>[];
  readOnly?: boolean;
  displaySelectAll: boolean;
  locale: string;
  cols?: number;
  className?: string;
  onChange: (value: CodeComplexValue<number>[]) => void;
}

export class CodeMultipleHierarchyPicker extends React.PureComponent<CodeMultipleHierarchyPickerProps, CodePickerState> {

  public readonly state: Readonly<CodePickerState> = { loadedOptions: {} };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions } = this.props;

    onLoadOptions(id, options);
    this.setState({ loadedOptions: options });
  };

  public render() {

    const { id, label, valueItems, options, fetchingOptions, translation, onChange, validation,
      searchRequired, readOnly, displaySelectAll, locale, cols, className, extraFooterButton } = this.props;

    return <div className={`col-lg-${cols ?? '6'} col-sm-12`}>
      <SelectMultipleHierarchy
        componentId={id}
        className={className ?? ''}
        label={label ? { text: label } : undefined}
        validation={validation}
        valueItems={valueItems || []}
        onChange={onChange}
        searchRequired={searchRequired}
        descriptionAllLevels={true}
        readOnly={readOnly}
        extraFooterButton={extraFooterButton}
        hideAlphabeticIndex={false}

        options={options}
        fetching={fetchingOptions}
        loadOptions={this.state.loadedOptions}
        onLoadOptions={this.onLoadOptions}
        placeholder={translation && translation.search}

        displaySelectAll={displaySelectAll}
        locale={locale}
      />
    </div>;
  }
}
